import { useContext, useState } from "react";
import FormInput from "../dashboardComponents/FormInput";
import FormButton from "../dashboardComponents/FormButton";
import { DashboardContext } from "../../../contextApi/DashboardContext";
import { AppContext } from "../../../contextApi/ContextApi";


export default function HomeHeaderForm({website}) {
    const {setToastMessage, messagesOptions} = useContext(AppContext);
    const {changeHeadersFlag, handleUpdateHomeHeader} = useContext(DashboardContext);
    const [mainHeader, setMainHeader] = useState(website?.settings?.homeHeaders?.main);
    const [subHeader, setSubHeader] = useState(website?.settings?.homeHeaders?.sub);

    
    return (
        <div className="dashboardForm" dir="rtl">
            <FormInput id={"homeHeaderForm_main"} type={"text"} _value={mainHeader} placeholder={mainHeader} onChangeAction={(e)=>{setMainHeader(e.target.value)}} hasLabel={true} label={"כותרת ראשית"} dir="rtl"/>
            <FormInput id={"homeHeaderForm_sub"} type={"text"} _value={subHeader} placeholder={subHeader} onChangeAction={(e)=>{setSubHeader(e.target.value)}} hasLabel={true} label={"כותרת משנית"} dir="rtl"/>
            <FormButton disabled={changeHeadersFlag} type={"button"} text={"עדכן"} action={()=>{handleUpdateHomeHeader(website, {main:mainHeader, sub:subHeader}, setToastMessage, messagesOptions)}}/>
        </div>
    )
}
